import React from 'react';
import PropTypes from 'prop-types';
import { TeamIcon } from 'common/react/components/TeamIcon';
import { getTranslation } from 'common/react/utils/translations';

export const DraftTrackerTable = ({ rows, seasonToShow }) => {
    return (
        <div>
            <div className="draft-tracker-embeddable-table">
                <div className="draft-tracker-embeddable-table__head">
                    <div className="draft-tracker-embeddable-table__head-row">
                        <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-pick__header">
                            {getTranslation('label.draftTrackerTable.pick')}
                        </div>
                        <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-club__header">
                            {getTranslation('label.draftTrackerTable.club')}
                        </div>
                        <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-player__header">
                            {getTranslation('label.draftTrackerTable.player')}
                        </div>
                        <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-total-from__header">
                            {getTranslation('label.draftTrackerTable.from')}
                        </div>
                    </div>
                </div>

                <div className="draft-tracker-embeddable-table__body">
                    {rows.map((row, i) => (
                        <div
                            key={i}
                            className={'draft-tracker-embeddable-table__row'}
                        >
                            <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-pick">
                                {row.pickNumber}
                            </div>
                            <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-club">
                                <TeamIcon
                                    providerId={row.teamId}
                                    className="draft-tracker-embeddable-table__cell-club__icon"
                                />
                            </div>
                            <a
                                href={PULSE.app.common.url.getProspectProfileURL(
                                    row.playerId,
                                    seasonToShow
                                )}
                                className="draft-tracker-embeddable-table__cell-details-link"
                            >
                                <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-player">
                                    {row.photoUrl ? (
                                        <div
                                            style={{
                                                backgroundImage: `url(${row.photoUrl}?im=Scale,width=0.2,height=0.2)`
                                            }}
                                            className="draft-tracker-embeddable-table__cell-player__image"
                                        />
                                    ) : (
                                        <div
                                            className={
                                                'draft-tracker-embeddable-table__cell-player__image__placeholder'
                                            }
                                        />
                                    )}
                                    <span className="draft-tracker-embeddable-table__cell-player__name">
                                        <span className="draft-tracker-embeddable-table__cell-player__name-text">
                                            {row.fullName}
                                        </span>
                                    </span>
                                </div>
                            </a>
                            <div className="draft-tracker-embeddable-table__cell draft-tracker-embeddable-table__cell-total-from">
                                <div className="draft-tracker-embeddable-table__cell-total-from__text">
                                    {row.juniorClub ?? ''}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

DraftTrackerTable.propTypes = {
    rows: PropTypes.array.isRequired,
    seasonToShow: PropTypes.string.isRequired
};
